





import Vue from 'vue'
import BaseText from '../atoms/BaseText.vue';

export default Vue.extend({
  components: {
    BaseText
  },
  computed: {
    currentYear(){
      if (!this.$store.state.month) return ''
      return this.$store.state.month > 3 ? this.$store.state.year: this.$store.state.year - 1
    },
    month() {
      if (!this.$store.state.month) return ''
      return this.$store.state.month
    },
  }
})
